import { render } from "./InsightListCard.vue?vue&type=template&id=856831ce&scoped=true&ts=true"
import script from "./InsightListCard.vue?vue&type=script&lang=ts"
export * from "./InsightListCard.vue?vue&type=script&lang=ts"

import "./InsightListCard.vue?vue&type=style&index=0&id=856831ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856831ce"]])

export default __exports__